import { render } from "./top-block.vue?vue&type=template&id=7006cb52&scoped=true"
const script = {}

import "./top-block.vue?vue&type=style&index=0&id=7006cb52&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7006cb52"]])

export default __exports__